import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "index",
      component: (resolve) => require(["@/pages/index/index"], resolve),
    },
    {
      path: "/signup",
      name: "index",
      component: (resolve) => require(["@/pages/index/index"], resolve),
    },
    {
      path: "/realavatar",
      name: "realavatar",
      component: (resolve) =>
        require(["@/pages/RealAvatar/index.vue"], resolve),
    },
    {
      path: "/apply",
      name: "apply",
      component: (resolve) => require(["@/pages/apply/apply"], resolve),
    },
    {
      path: "/ENapply",
      name: "ENapply",
      component: (resolve) => require(["@/pages/applyEN/apply"], resolve),
    },
    {
      path: "/other",
      name: "other",
      component: (resolve) => require(["@/pages/other/other"], resolve),
    },
    {
      path: "/success",
      name: "success",
      component: (resolve) => require(["@/components/submit"], resolve),
    },
    {
      path: "/successEN",
      name: "successEN",
      component: (resolve) => require(["@/components/submitEN"], resolve),
    },
    {
      path: "/success2",
      name: "success2",
      component: (resolve) => require(["@/pages/pay/success2"], resolve),
    },
    {
      path: "/login",
      name: "login",
      component: (resolve) => require(["@/pages/pay/login"], resolve),
    },
    {
      path: "/login-app",
      name: "login-app",
      component: (resolve) => require(["@/pages/pay/login-app"], resolve),
    },
    {
      path: "/user",
      name: "user",
      component: (resolve) => require(["@/pages/pay/user"], resolve),
    },
    {
      path: "/clear",
      name: "clear",
      component: (resolve) => require(["@/pages/pay/clear"], resolve),
    },
    {
      path: "/order",
      name: "order",
      component: (resolve) => require(["@/pages/pay/order"], resolve),
    },
    {
      path: "/paySuccess",
      name: "paySuccess",
      component: (resolve) => require(["@/pages/pay/paySuccess"], resolve),
    },
    {
      path: "/payError",
      name: "payError",
      component: (resolve) => require(["@/pages/pay/payError"], resolve),
    },

    {
      path: "/paymentSuccess",
      name: "paymentSuccess",
      component: (resolve) => require(["@/pages/pay/paymentSuccess"], resolve),
    },
    {
      path: "/paymentError",
      name: "paymentError",
      component: (resolve) => require(["@/pages/pay/paymentError"], resolve),
    },
    {
      path: "/treaty",
      name: "treaty",
      component: (resolve) => require(["@/pages/pay/treaty"], resolve),
    },
    {
      path: "/agreement",
      name: "agreement",
      component: (resolve) => require(["@/pages/pay/agreement"], resolve),
    },
    {
      path: "/vipbroker",
      name: "vipbroker",
      component: (resolve) => require(["@/pages/vipbroker/index"], resolve),
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js